var _linearGradient, _radialGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _radialGradient2, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _radialGradient3, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _radialGradient4, _radialGradient5, _radialGradient6, _linearGradient46, _radialGradient7, _linearGradient47, _linearGradient48, _radialGradient8, _linearGradient49, _radialGradient9, _radialGradient10, _radialGradient11, _linearGradient50, _radialGradient12, _linearGradient51, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "1 -7 511.999 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5071,
    stopColor: "#ffe346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6898,
    stopColor: "#ffdd3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffd234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9245,
    stopColor: "#ffc223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 153.8375,
    cy: -121.481,
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    r: 155.9438,
    xlinkHref: "#a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb211",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1722,
    stopColor: "#ffad13",
    stopOpacity: 0.172549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#ff9e1a",
    stopOpacity: 0.384314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#ff8525",
    stopOpacity: 0.615686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8577,
    stopColor: "#ff6334",
    stopOpacity: 0.858824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4b3e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    x1: 224.2299,
    x2: 213.6066,
    xlinkHref: "#c",
    y1: -158.1327,
    y2: -186.6174
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ac943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4564,
    stopColor: "#5fc146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39b54a"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(.801832 -.60416 .60416 .801832 457.570786 412.381884)",
    gradientUnits: "userSpaceOnUse",
    x1: -7.3706,
    x2: 19.104,
    xlinkHref: "#e",
    y1: -479.4895,
    y2: -448.1273
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39b54a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1072,
    stopColor: "#2fab48",
    stopOpacity: 0.105882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4553,
    stopColor: "#159043",
    stopOpacity: 0.454902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7642,
    stopColor: "#06803f",
    stopOpacity: 0.764706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007a3e"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(.801832 -.60416 .60416 .801832 457.570786 412.381884)",
    gradientUnits: "userSpaceOnUse",
    x1: 8.7913,
    x2: -15.442,
    xlinkHref: "#g",
    y1: -463.9223,
    y2: -485.5083
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(.801832 -.60416 .60416 .801832 457.570786 412.381884)",
    gradientUnits: "userSpaceOnUse",
    x1: -12.8116,
    x2: -6.4983,
    xlinkHref: "#g",
    y1: -478.2861,
    y2: -470.1399
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c08552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895738"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    x1: 178.2816,
    x2: 203.1056,
    xlinkHref: "#j",
    y1: -196.5873,
    y2: -196.5873
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    x1: 222.0369,
    x2: 194.9012,
    xlinkHref: "#c",
    y1: -141.7532,
    y2: -200.4139
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    x1: 205.8822,
    x2: 321.3439,
    xlinkHref: "#c",
    y1: -71.0316,
    y2: -111.4431
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 202.2685,
    cy: -201.1357,
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    r: 33.6569,
    xlinkHref: "#a"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0013,
    stopColor: "#e7eeed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7731,
    stopColor: "#f9fbfa",
    stopOpacity: 0.772549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientTransform: "matrix(.914372 -.414419 .414419 .914372 51.528282 313.862543)",
    gradientUnits: "userSpaceOnUse",
    x1: 171.221,
    x2: 72.0091,
    xlinkHref: "#o",
    y1: -71.347,
    y2: -138.2191
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1916.866259 -570.41858)",
    gradientUnits: "userSpaceOnUse",
    x1: 2006.623,
    x2: 2084.8198,
    xlinkHref: "#e",
    y1: -1153.6836,
    y2: -1153.6836
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1916.866259 -570.41858)",
    gradientUnits: "userSpaceOnUse",
    x1: 2072.6511,
    x2: 2036.9232,
    xlinkHref: "#g",
    y1: -1153.2997,
    y2: -1153.2997
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 334.33112405,
    x2: 350.6747734256,
    xlinkHref: "#g",
    y1: 24.248450781,
    y2: 95.9242651086
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1916.866259 -570.41858)",
    gradientUnits: "userSpaceOnUse",
    x1: 2004.4618,
    x2: 2121.2456,
    y1: -1003.2894,
    y2: -1003.2894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4b3e"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b3e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1177,
    stopColor: "#f5493b",
    stopOpacity: 0.117647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#da4332",
    stopOpacity: 0.317647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5796,
    stopColor: "#ad3923",
    stopOpacity: 0.580392
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#702c0f",
    stopOpacity: 0.886275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#582707"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1916.866259 -570.41858)",
    gradientUnits: "userSpaceOnUse",
    x1: 2066.6775,
    x2: 2025.3561,
    xlinkHref: "#u",
    y1: -1076.5657,
    y2: -1118.2806
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientTransform: "matrix(.752138 .629961 -.644618 .769606 -1741.174061 -437.790402)",
    gradientUnits: "userSpaceOnUse",
    x1: 1968.1395,
    x2: 1967.2466,
    xlinkHref: "#u",
    y1: -855.6654,
    y2: -841.8251
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientTransform: "matrix(.769606 .644618 -.644618 .769606 -1738.154667 -435.039456)",
    gradientUnits: "userSpaceOnUse",
    x1: 1902.1193,
    x2: 1901.2263,
    xlinkHref: "#u",
    y1: -784.5808,
    y2: -770.7411
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientTransform: "matrix(.987658 .620725 -.727542 1.157722 -1877.692235 562.679183)",
    gradientUnits: "userSpaceOnUse",
    x1: 1373.4117,
    x2: 1372.519,
    xlinkHref: "#u",
    y1: -1123.0609,
    y2: -1109.2223
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientTransform: "matrix(.828235 .567416 -.567416 .828235 -1530.700198 -312.821944)",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.576,
    x2: 1740.6472,
    xlinkHref: "#u",
    y1: -637.4296,
    y2: -623.0328
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientTransform: "matrix(.661785 .453471 -.567416 .828235 -1580.228267 -345.985388)",
    gradientUnits: "userSpaceOnUse",
    x1: 2239.8484,
    x2: 2238.9197,
    xlinkHref: "#u",
    y1: -593.4421,
    y2: -579.0472
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientTransform: "matrix(.661785 .453471 -.567416 .828235 -1580.228267 -345.985388)",
    gradientUnits: "userSpaceOnUse",
    x1: 2238.9255,
    x2: 2237.9968,
    xlinkHref: "#u",
    y1: -555.92,
    y2: -541.5251
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientTransform: "matrix(1.048195 .718105 -.567416 .828235 -1454.903015 -260.948111)",
    gradientUnits: "userSpaceOnUse",
    x1: 1299.6013,
    x2: 1298.6725,
    xlinkHref: "#u",
    y1: -609.2393,
    y2: -594.8424
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 342.5787448488,
    cy: 83.0468572224,
    gradientUnits: "userSpaceOnUse",
    r: 213.231024956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4462,
    stopColor: "#fd4a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6069,
    stopColor: "#f64939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    stopColor: "#eb4533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8141,
    stopColor: "#da412a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8935,
    stopColor: "#c43a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9625,
    stopColor: "#a93311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972e07"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 359.9614648984,
    x2: 378.2660751166,
    xlinkHref: "#e",
    y1: 94.1282111698,
    y2: 94.3788904932
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972e07",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#582707"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 354.296120864,
    x2: 296.9798044712,
    xlinkHref: "#F",
    y1: 139.8963498852,
    y2: 82.5801338846
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 315.9793294978,
    x2: 185.8218461198,
    xlinkHref: "#o",
    y1: 179.4717582628,
    y2: 91.7412233112
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 405.021789719,
    x2: 351.353123521,
    xlinkHref: "#F",
    y1: 191.7243250962,
    y2: 50.4130675138
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientTransform: "matrix(.99579 .127498 -.127498 .99579 -783.043865 24.599308)",
    gradientUnits: "userSpaceOnUse",
    x1: 1140.744,
    x2: 1164.4512,
    xlinkHref: "#e",
    y1: -33.0719,
    y2: -39.0701
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientTransform: "matrix(.807555 .596329 -.596329 .807555 -1305.145625 -929.262314)",
    gradientUnits: "userSpaceOnUse",
    x1: 1920.4495,
    x2: 1940.5374,
    xlinkHref: "#e",
    y1: -137.2997,
    y2: -123.5358
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientTransform: "matrix(-.807555 .596329 .596329 .807555 2770.524762 -929.262314)",
    gradientUnits: "userSpaceOnUse",
    x1: 2509.1892,
    x2: 2529.2771,
    xlinkHref: "#e",
    y1: -572.0479,
    y2: -558.2839
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientTransform: "matrix(.99579 .127498 -.127498 .99579 -783.043865 24.599308)",
    gradientUnits: "userSpaceOnUse",
    x1: 1109.9047,
    x2: 1130.9851,
    xlinkHref: "#e",
    y1: -44.1778,
    y2: -29.7338
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientTransform: "matrix(-.999404 .094971 .094971 .999404 1344.192552 69.363067)",
    gradientUnits: "userSpaceOnUse",
    x1: 937.58,
    x2: 958.6602,
    xlinkHref: "#e",
    y1: -35.0377,
    y2: -20.5938
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientTransform: "matrix(.964166 -.279893 .279893 .964166 -739.852348 1178.799001)",
    gradientUnits: "userSpaceOnUse",
    x1: 1100.1302,
    x2: 1126.4839,
    xlinkHref: "#e",
    y1: -794.0041,
    y2: -762.7852
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientTransform: "matrix(.964166 -.279893 .279893 .964166 -739.852348 1178.799001)",
    gradientUnits: "userSpaceOnUse",
    x1: 1116.2183,
    x2: 1092.0946,
    xlinkHref: "#g",
    y1: -778.5082,
    y2: -799.9965
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientTransform: "matrix(.964166 -.279893 .279893 .964166 -739.852348 1178.799001)",
    gradientUnits: "userSpaceOnUse",
    x1: 1094.7142,
    x2: 1100.9985,
    xlinkHref: "#g",
    y1: -792.8062,
    y2: -784.6973
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 214.1708,
    x2: 234.084,
    xlinkHref: "#j",
    y1: -229.5476,
    y2: -223.6058
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#895738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e3023"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 238.0992,
    x2: 231.2937,
    xlinkHref: "#S",
    y1: -250.3857,
    y2: -242.7295
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 220.7259,
    x2: 229.1208,
    xlinkHref: "#S",
    y1: -223.05,
    y2: -228.8065
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 224.0989,
    x2: 230.7394,
    xlinkHref: "#S",
    y1: -234.1871,
    y2: -195.5157
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "W",
    cx: 214.2542,
    cy: -58.473,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#9e4a8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#8e3a94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9681,
    stopColor: "#73209f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701da0"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "X",
    cx: 236.6558,
    cy: -84.144,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2732,
    stopColor: "#9b478f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7168,
    stopColor: "#833098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701da0"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Y",
    cx: 253.1304,
    cy: -120.5194,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#9f4b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5684,
    stopColor: "#903d93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9021,
    stopColor: "#78259d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701da0"
  }))), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#a14d8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5737,
    stopColor: "#974490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7918,
    stopColor: "#873497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#711ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701da0"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aa",
    cx: 283.9439,
    cy: -154.3376,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7229,
    xlinkHref: "#Z"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#701da0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f004e"
  }))), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 275.2452,
    x2: 231.5717,
    xlinkHref: "#ab",
    y1: -89.5209,
    y2: -123.8358
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ad",
    cx: 195.5304,
    cy: -91.0089,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#9d498e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6193,
    stopColor: "#8b3795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701da0"
  }))), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 213.2983,
    x2: 193.5833,
    xlinkHref: "#ab",
    y1: -75.0919,
    y2: -118.7848
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "af",
    cx: 217.3254,
    cy: -128.0192,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4508b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    stopColor: "#9f4b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#903c93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#78249d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701da0"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ag",
    cx: 244.4662,
    cy: -163.7958,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7229,
    xlinkHref: "#Z"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ah",
    cx: 267.2783,
    cy: -190.7633,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7229,
    xlinkHref: "#Z"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 250.4862,
    x2: 200.2467,
    xlinkHref: "#ab",
    y1: -128.5511,
    y2: -178.7905
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "aj",
    cx: 173.1289,
    cy: -122.5348,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.723,
    xlinkHref: "#Z"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    x1: 195.3176,
    x2: 144.6782,
    xlinkHref: "#ab",
    y1: -107.9579,
    y2: -173.7634
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "al",
    cx: 199.7608,
    cy: -159.4962,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7231,
    xlinkHref: "#Z"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "am",
    cx: 157.6408,
    cy: -154.0322,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.723,
    xlinkHref: "#Z"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "an",
    cx: 222.1454,
    cy: -195.5156,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7228,
    xlinkHref: "#Z"
  })), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ao",
    cx: 178.084,
    cy: -192.2965,
    gradientTransform: "matrix(.809362 -.59392 .59392 .809362 21.828467 455.402634)",
    gradientUnits: "userSpaceOnUse",
    r: 42.7232,
    xlinkHref: "#Z"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    gradientUnits: "userSpaceOnUse",
    x1: 256.6430216488,
    x2: 349.3449783444,
    xlinkHref: "#j",
    y1: 289.7415468208,
    y2: 555.0118725688
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    gradientUnits: "userSpaceOnUse",
    x1: 299.6489318926,
    x2: 299.6489318926,
    xlinkHref: "#S",
    y1: 314.2622412786,
    y2: 742.1739545586
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    gradientUnits: "userSpaceOnUse",
    x1: 318.010866057,
    x2: 318.010866057,
    xlinkHref: "#S",
    y1: 344.0669787912,
    y2: 646.3746977086
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    gradientUnits: "userSpaceOnUse",
    x1: 336.6389399436,
    x2: 336.6389399436,
    xlinkHref: "#S",
    y1: 275.941735401,
    y2: 617.634117516
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    gradientUnits: "userSpaceOnUse",
    x1: 369.7999894866,
    x2: 369.7999894866,
    xlinkHref: "#S",
    y1: 258.9104998476,
    y2: 678.3065451548
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1654.530911 -6.682888)",
    gradientUnits: "userSpaceOnUse",
    x1: 1436.5461,
    x2: 1436.5461,
    xlinkHref: "#S",
    y1: 319.6913,
    y2: 745.9313
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1654.530911 -6.682888)",
    gradientUnits: "userSpaceOnUse",
    x1: 1454.8363,
    x2: 1454.8363,
    xlinkHref: "#S",
    y1: 349.3796,
    y2: 650.5063
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1654.530911 -6.682888)",
    gradientUnits: "userSpaceOnUse",
    x1: 1473.3916,
    x2: 1473.3916,
    xlinkHref: "#S",
    y1: 281.5205,
    y2: 621.878
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1654.530911 -6.682888)",
    gradientUnits: "userSpaceOnUse",
    x1: 1506.4231,
    x2: 1506.4231,
    xlinkHref: "#S",
    y1: 264.5558,
    y2: 682.3134
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#S",
    y1: 447.3812945566,
    y2: 164.0582426202
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    y1: 204.5306553048,
    y2: 272.0905902168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#ffe042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ffd133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9123,
    stopColor: "#ffb919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m207.933594 73.550781c-7.566406-16.691406-27.230469-24.09375-43.925782-16.527343l-15.769531 7.148437c-16.695312 7.566406-24.09375 27.234375-16.527343 43.925781v.003906c5.308593 11.714844 5.808593 25.089844 1.183593 37.09375-7.398437 19.203126-7.421875 41.234376 1.671875 61.476563 18.039063 40.164063 59.933594 45.640625 100.074219 27.539063 40.308594-18.175782 63.898437-53.027344 45.652344-93.285157-9.140625-20.171875-25.621094-34.707031-44.851563-41.886719-12.1875-4.546874-22.136718-13.640624-27.507812-25.488281zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m224.417969 93.269531-57.382813-21.574219-2.699218-1.015624-.269532-.035157-.277344-.03125c-.007812-.050781-.015624-.105469-.027343-.15625-.800781-.519531-3.085938-2.070312-5.738281-4.539062.320312-.101563.636718-.214844.929687-.347657 3.296875-1.492187 6.191406-5.753906 9.5-10.191406 11.953125-3.488281 24.714844.089844 33.128906 8.808594 2.574219 2.660156 4.738281 5.796875 6.351563 9.359375 3.636718 8.023437 9.375 14.785156 16.484375 19.722656zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m161.277344 66.929688s-44.996094-27.25 9.730468-65.5c2.28125-1.597657 5.417969-1.085938 7.105469 1.128906 8.117188 10.660156 26.117188 41.605468-16.835937 64.371094zm0 0",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m178.113281 2.558594c-.933593-1.226563-2.316406-1.929688-3.75-2.042969-10.019531 30.574219-13.089843 66.414063-13.089843 66.414063 42.957031-22.765626 24.957031-53.710938 16.839843-64.371094zm0 0",
    fill: "url(#h)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m174.886719 21.683594c-.390625.371094-.804688.71875-1.210938 1.066406s-.808593.695312-1.226562 1.019531c-.414063.332031-.878907.609375-1.328125.886719-.453125.277344-.847656.613281-1.1875 1.011719-.335938.40625-.65625.824219-.953125 1.296875.097656-.722656.195312-1.441406.289062-2.167969l.511719-3.523437c.164062-1.179688.398438-2.335938.582031-3.511719.40625-2.34375.898438-4.652344 1.550781-6.933594l-.511718-.214844-.761719 1.644531-.382813.828126c-.121093.277343-.21875.5625-.328124.839843-.417969 1.128907-.886719 2.257813-1.242188 3.402344-.78125 2.285156-1.441406 4.597656-2.121094 6.910156-.117187.449219-.234375.894531-.355468 1.34375-.160157-.351562-.339844-.691406-.582032-1-.320312-.421875-.65625-.847656-.921875-1.304687-.277343-.453125-.527343-.921875-.78125-1.394532-.253906-.46875-.519531-.941406-.746093-1.429687-.507813-.960937-.917969-1.96875-1.375-2.992187l-.300782.054687c-.019531 1.125.046875 2.261719.207032 3.386719.078124.566406.191406 1.125.300781 1.6875.136719.554687.273437 1.109375.441406 1.660156.164063.550781.296875 1.117188.457031 1.679688.167969.558593.429688 1.078124.796875 1.53125.074219.089843.148438.179687.222657.265624.832031.941407 1.132812 2.242188.835937 3.464844l-.007813.023438c-.511718 2.128906-.980468 4.261718-1.457031 6.394531-.234375-.488281-.5-.929687-.78125-1.359375-.296875-.433594-.644531-.8125-1.066406-1.140625-.414063-.328125-.847656-.652344-1.21875-1.03125-.382813-.367187-.742187-.757813-1.105469-1.152344-.363281-.390625-.738281-.78125-1.082031-1.195312-.726563-.804688-1.378906-1.679688-2.074219-2.554688l-.28125.128907c.265625 1.09375.613282 2.175781 1.050782 3.226562.214843.53125.464843 1.039062.710937 1.558594.273437.5.546875 1.007812.84375 1.496094.296875.492187.566406 1.007812.863281 1.511718.304688.5.6875.9375 1.152344 1.285156.210938.152344.425781.296876.652344.433594 1.097656.65625 1.605468 1.980469 1.308594 3.226563-.253907 1.070312-.507813 2.136719-.757813 3.207031-.3125 1.355469-.558594 2.722656-.75 4.097656-.210937-.417968-.441406-.804687-.6875-1.175781-.296875-.4375-.644531-.816406-1.066406-1.140625-.414063-.328125-.847657-.652344-1.21875-1.03125-.382813-.371094-.742188-.761719-1.105469-1.152344s-.738281-.785156-1.082031-1.199218c-.726563-.804688-1.378907-1.675782-2.074219-2.550782l-.28125.128906c.261719 1.09375.609375 2.175782 1.050781 3.226563.214844.527344.464844 1.039063.710938 1.558594.273437.5.546875 1.003906.84375 1.492187.296875.492188.566406 1.011719.863281 1.515625.304688.496094.6875.933594 1.152344 1.285157.46875.339843.976562.652343 1.542968.878906.644532.261718 1.066407.886718 1.03125 1.582031-.09375 1.804687-.234374 5.070313-.191406 6.808594.078125 2.421875.25 4.855469.746094 7.324219l.546875.066406c1.074219-2.269532 1.871094-4.566406 2.574219-6.871094.695312-2.308594 1.285156-4.628906 1.78125-6.957031.007812-.042969.015625-.085938.023437-.125.160157-.753907.816407-1.265625 1.585938-1.292969.566406-.023438 1.109375-.125 1.632812-.265625.5625-.160156 1.074219-.429687 1.539063-.785156.457031-.367188.894531-.75 1.347656-1.105469.453125-.347656.890625-.722656 1.320312-1.09375.417969-.394531.832032-.785156 1.222657-1.199219.785156-.824219 1.5-1.710937 2.136719-2.636719l-.214844-.222656c-.964844.570313-1.882813 1.148438-2.855469 1.640625-.46875.265625-.957031.496094-1.4375.730469-.480469.238281-.957031.472656-1.445313.683594-.480468.21875-1 .367187-1.507812.523437s-.96875.382813-1.402344.683594c-.464844.335937-.914062.699219-1.351562 1.132813.183594-1.238282.320312-2.476563.421875-3.722657.066406-1 .179687-2.34375.277343-3.523437.105469-1.253906.992188-2.328125 2.21875-2.605469.601563-.132813 1.175782-.355469 1.722657-.503906.5625-.160157 1.074219-.429688 1.535156-.785157.457031-.367187.898437-.75 1.347656-1.105468.457031-.347656.890625-.722656 1.324219-1.09375.417969-.394532.832031-.78125 1.222656-1.199219.785156-.824219 1.5-1.710937 2.132813-2.636719l-.210938-.21875c-.964843.570313-1.882812 1.148438-2.855469 1.640625-.46875.261719-.957031.496094-1.4375.730469-.480468.234375-.957031.472656-1.445312.679688-.480469.21875-1 .371093-1.507812.527343-.507813.152344-.96875.382813-1.402344.683594-.816406.585937-1.589844 1.257813-2.328125 2.277344.277343-2.355469.539062-4.71875.855469-7.070313l.007812-.089844c.160156-1.433593 1.070312-2.710937 2.417969-3.226562.378906-.144531.738281-.324219 1.085937-.519531.503906-.292969.933594-.6875 1.292969-1.144531.347656-.46875.675781-.949219 1.027344-1.40625.351562-.453126.679687-.921876 1.007812-1.390626.300781-.488281.609375-.964843.882813-1.46875.554687-.992187 1.023437-2.027343 1.40625-3.085937l-.261719-.160156c-.789063.785156-1.53125 1.578125-2.347656 2.296875zm0 0",
    fill: "url(#i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m166.625 73.875c-1.113281.621094-2.28125 1.214844-3.496094 1.765625-.855468.386719-1.707031.746094-2.558594 1.066406-2.769531-5.835937-6.683593-12.761719-11.898437-19.097656-3.101563-3.777344-6.667969-7.347656-10.726563-10.359375-6.863281-5.082031-11.96875-6.164062-12.023437-6.175781-1.800781-.367188-2.976563-2.121094-2.625-3.921875.359375-1.800782 2.089844-2.984375 3.890625-2.640625.734375.136719 14.027344 2.878906 27.574219 19.960937 4.042969 5.089844 8.101562 11.449219 11.863281 19.402344zm0 0",
    fill: "url(#k)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m229.890625 95.328125c-.339844.238281-.679687.472656-1.023437.699219-2.109376 1.417968-4.34375 2.648437-6.648438 3.699218-4.441406 2.003907-9.175781 3.363282-14.058594 3.804688-2.429687.210938-4.902344.167969-7.324218-.234375-1.46875-.238281-2.9375-.625-4.304688-1.207031l-52.753906-23.066406c-1.285156-.433594-2.515625-1.015626-3.601563-1.789063.59375.101563 7.371094 1.601563 9.5625 1.085937 4.390625-1.011718 8.660157-2.546874 12.765625-4.386718 1.535156-.699219 3.046875-1.441406 4.53125-2.238282 2.484375-1.335937 4.890625-2.8125 7.183594-4.464843 1.824219-1.320313 3.585938-2.746094 5.191406-4.34375.8125-.796875 1.558594-1.644531 2.292969-2.539063.699219-.902344 1.351563-1.863281 1.929687-2.910156l17.953126 6.75c2.570312 2.660156 4.734374 5.800781 6.351562 9.363281 3.636719 8.019531 9.371094 14.78125 16.484375 19.71875zm0 0",
    fill: "url(#l)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m279.644531 139.542969c-.078125-.164063-.148437-.328125-.226562-.488281-.15625-.320313-.320313-.640626-.480469-.960938-.148438-.292969-.289062-.585938-.441406-.875-.140625-.277344-.289063-.546875-.433594-.820312-.175781-.328126-.347656-.660157-.523438-.984376-.140624-.257812-.289062-.507812-.429687-.761718-.191406-.339844-.378906-.679688-.574219-1.011719-.132812-.230469-.269531-.453125-.40625-.679687-.210937-.355469-.417968-.710938-.632812-1.058594-.125-.203125-.257813-.402344-.382813-.605469-.234375-.367187-.460937-.734375-.699219-1.097656-.117187-.183594-.242187-.363281-.363281-.546875-.25-.375-.5-.753906-.753906-1.125-.113281-.164063-.230469-.324219-.347656-.488282-.265625-.382812-.535157-.765624-.808594-1.144531-.105469-.148437-.21875-.292969-.328125-.441406-.285156-.386719-.570312-.777344-.863281-1.160156-.09375-.121094-.191407-.242188-.285157-.367188-.3125-.398437-.625-.800781-.941406-1.195312-.085937-.105469-.171875-.207031-.253906-.308594-.335938-.410156-.667969-.816406-1.007812-1.21875-.078126-.089844-.152344-.175781-.230469-.265625-.351563-.410156-.707031-.824219-1.066407-1.226562-.0625-.070313-.125-.136719-.1875-.207032-.378906-.421875-.757812-.839844-1.144531-1.25-.046875-.050781-.097656-.101562-.148437-.15625-.402344-.425781-.804688-.84375-1.210938-1.261718-.039062-.035157-.074218-.074219-.113281-.109376-.421875-.429687-.847656-.855468-1.28125-1.269531-.023437-.023437-.050781-.046875-.074219-.070312-.445312-.429688-.894531-.855469-1.351562-1.273438-.011719-.011719-.023438-.023437-.035156-.03125-7.65625-7.039062-16.570313-12.457031-26.171876-16.042969-.023437-.007812-.042968-.015624-.066406-.023437-19.085937-7.109375-40.875-6.972656-60.890625 2.101563-19.929687 9.03125-34.355469 25.226562-41.621093 44.15625-.199219.515624-.390626 1.035156-.578126 1.550781-.03125.089843-.0625.175781-.09375.261719-.183593.515624-.359374 1.03125-.53125 1.550781-.03125.089843-.0625.1875-.09375.277343-.171874.515626-.332031 1.027344-.492187 1.542969-.03125.101563-.0625.203125-.09375.304688-.152344.507812-.300781 1.019531-.445313 1.53125-.03125.109375-.0625.21875-.09375.324219-.136718.507812-.273437 1.011718-.402343 1.519531-.03125.117187-.0625.238281-.089844.355469-.128906.5-.246094 1.003906-.363281 1.503906-.027344.128906-.058594.253906-.089844.378906-.109375.496094-.214844.996094-.320312 1.492188-.027344.136718-.054688.269531-.082032.402343-.097656.492188-.191406.980469-.277344 1.472657-.027343.144531-.054687.289062-.082031.4375-.082031.480468-.160156.964843-.238281 1.449218-.023438.15625-.050781.308594-.074219.464844-.070312.476562-.132812.953125-.199219 1.429688-.019531.167968-.042968.332031-.066406.496093-.058594.46875-.109375.9375-.160156 1.40625-.019531.175781-.039062.351563-.058594.527344-.046875.460937-.085937.921875-.125 1.382813-.015625.183593-.035156.371093-.046875.554687-.035156.453125-.0625.90625-.089843 1.359375-.011719.195312-.027344.390625-.035157.585938-.023437.445312-.042969.890624-.054687 1.332031-.007813.207031-.015625.414062-.023438.621093-.011718.433594-.015625.871094-.023437 1.304688 0 .21875-.003907.433594-.003907.648438-.003906.425781.003907.851562.007813 1.28125.003906.226562.003906.453124.007813.679687.007812.417969.023437.835937.039062 1.25.011719.238281.019531.472656.027344.710937.019531.40625.046875.816407.070312 1.226563.015625.246094.03125.492187.046875.734375.027344.402344.0625.800781.097657 1.203125.023437.253906.042968.507813.066406.761719.039062.390625.082031.78125.125 1.175781.03125.261719.058594.523437.089844.785156.046874.382813.101562.765625.152343 1.148438.035157.273437.070313.542969.109375.816406.058594.375.117188.75.179688 1.121094.042968.28125.085937.5625.136718.839843.0625.367188.132813.734376.199219 1.101563.054688.285156.105469.570313.164063.855469.070312.359375.148437.71875.222656 1.082031.0625.289063.125.582031.191406.871094.078125.355469.164063.707031.25 1.0625.070313.296875.136719.59375.214844.886719.085938.351562.179688.695312.273438 1.046874.078124.300782.15625.597657.238281.898438.097656.34375.199219.683594.296875 1.027344.089844.304687.179687.609375.269531.914062.105469.335938.214844.671875.324219 1.007813.097656.308593.191406.617187.296875.921875.109375.335937.226562.664062.34375.996094.109375.3125.214843.621093.324219.929687.121093.328125.246093.65625.371093.984375.117188.3125.230469.621094.351563.929688.128906.328124.261718.652343.394531.976562.125.308594.25.621094.378906.929688.136719.324218.28125.648437.421875.96875.136719.308593.269532.621093.40625.929687.152344.332031.304688.65625.457032.984375.132812.285156.265624.570312.398437.851562.257813.527344.515625 1.042969.777344 1.558594.027343.050782.050781.105469.078125.15625 18.902344 36.808594 59.425781 41.394532 98.308594 23.863282 40.085937-18.078126 63.628906-52.644532 45.945312-92.617188-.101562-.222656-.195312-.445312-.292969-.667969-.21875-.464843-.4375-.925781-.65625-1.382812zm0 0",
    fill: "url(#m)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb211"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.542969 107.230469c-.539063-1.195313-1.949219-1.722657-3.140625-1.183594-1.195313.542969-1.726563 1.949219-1.183594 3.144531.539062 1.195313 1.949219 1.722656 3.140625 1.179688 1.195313-.539063 1.726563-1.945313 1.183594-3.140625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.15625 100.441406c-.855469-1.890625-3.085938-2.730468-4.976562-1.875-1.890626.859375-2.726563 3.085938-1.871094 4.976563.855468 1.894531 3.085937 2.730469 4.976562 1.875 1.890625-.859375 2.730469-3.085938 1.871094-4.976563zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.894531 94.019531c-1.316406-2.910156-4.746093-4.199219-7.65625-2.878906-2.910156 1.316406-4.199219 4.746094-2.878906 7.65625 1.316406 2.910156 4.746094 4.199219 7.65625 2.878906 2.910156-1.316406 4.199219-4.746093 2.878906-7.65625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.203125 183.738281c-.542969-1.191406-1.949219-1.722656-3.144531-1.179687-1.191406.539062-1.722656 1.945312-1.179688 3.140625.539063 1.195312 1.949219 1.722656 3.140625 1.183593 1.195313-.542968 1.726563-1.949218 1.183594-3.144531zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.554688 170.527344c-1.320313-2.90625-4.746094-4.199219-7.65625-2.878906-2.910157 1.320312-4.199219 4.746093-2.882813 7.65625 1.320313 2.910156 4.746094 4.199218 7.65625 2.882812 2.910156-1.320312 4.199219-4.75 2.882813-7.660156zm0 0"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m179.863281 54.054688c.105469 2.929687-.570312 5.652343-1.542969 8.039062-.980468 2.402344-2.316406 4.476562-3.808593 6.332031-3.019531 3.679688-6.75 6.40625-10.839844 8.269531-4.105469 1.847657-8.597656 2.863282-13.359375 2.710938-2.375-.082031-4.828125-.480469-7.277344-1.316406-2.4375-.832032-4.929687-2.136719-7.0625-4.140625.605469.210937 1.179688.476562 1.769532.617187.574218.203125 1.15625.3125 1.726562.449219 1.144531.199219 2.265625.378906 3.371094.414063 2.210937.117187 4.367187-.007813 6.464844-.332032 4.195312-.632812 8.203124-1.921875 12-3.621094 3.796874-1.726562 7.390624-3.890624 10.636718-6.636718 1.617188-1.375 3.15625-2.882813 4.519532-4.636719.6875-.867187 1.308593-1.8125 1.90625-2.8125.566406-1.023437 1.074218-2.117187 1.496093-3.335937zm0 0",
    fill: "url(#n)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m233.605469 158.265625c13.070312 28.84375 3.011719 61.582031-22.46875 73.132813-25.476563 11.546874-56.730469-2.46875-69.800781-31.3125-13.070313-28.839844-3.011719-61.578126 22.464843-73.128907 25.480469-11.546875 56.730469 2.46875 69.804688 31.308594zm0 0",
    fill: "url(#p)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m369.695312 101.0625c-10.261718 16.78125-49.976562 9.015625-60.222656 6.691406-1.554687-.355468-2.425781-.585937-2.425781-.585937s-.183594-.453125-.484375-1.28125c-.1875-.511719-.417969-1.171875-.683594-1.957031-2.761718-8.195313-8.859375-29.996094-.449218-41.96875 10.5-14.949219 14.347656 3.085937 14.347656 3.085937s1.503906-26.214844 14.882812-38.027344c13.210938-11.65625 12.304688 10.984375 12.277344 11.574219.152344-.578125 7.136719-26.457031 22.972656-26.707031 16.015625-.261719 4.757813 17.988281 4.757813 17.988281s17.804687-17.613281 28.472656-9.695312c1.453125 1.078124 2.285156 2.292968 2.632813 3.582031.003906.015625.011718.035156.015624.050781.023438.101562.050782.207031.070313.3125.027344.121094.046875.242188.0625.367188.015625.121093.027344.246093.035156.367187.019531.242187.023438.492187.007813.742187 0 .019532-.003906.035157-.003906.054688-.007813.113281-.015626.222656-.023438.328125-.023438.207031-.054688.410156-.09375.621094-.035156.171875-.074219.347656-.117188.527343-.03125.128907-.070312.253907-.109374.382813-.039063.128906-.082032.261719-.125.386719-.046876.128906-.09375.257812-.144532.390625-.101562.257812-.214844.515625-.339844.777343-.050781.113282-.105468.222657-.164062.335938-.074219.148438-.152344.292969-.230469.4375-.070312.132812-.148437.261719-.222656.390625-.074219.132813-.15625.257813-.234375.386719-.078125.132812-.164062.257812-.246094.386718-.421875.640626-.890625 1.285157-1.394531 1.910157-.171875.222656-.355469.4375-.539063.65625-.132812.15625-.265624.308593-.402343.464843-.183594.203126-.367188.40625-.554688.609376-.019531.027343-.042969.046874-.0625.070312-.070312.074219-.140625.152344-.210937.222656-4.246094 4.5-9.566406 8.039063-9.800782 8.199219.371094-.089844 14.078126-3.3125 17.589844 5.738281 3.535156 9.101563-30.523437 15.316406-31.058594 15.414063.371094.097656 18.296876 4.875 14.785157 15.199219-3.519531 10.351562-38.839844 10.199218-39.382813 10.195312.492188.082031 21.539063 3.652344 16.816406 11.375zm0 0",
    fill: "url(#q)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m369.695312 101.0625c-10.261718 16.78125-49.976562 9.015625-60.222656 6.691406-1.554687-.355468-2.425781-.585937-2.425781-.585937s-.183594-.453125-.484375-1.28125c21.480469-28.851563 48.085938-50.292969 69.730469-64.707031 11.875-7.898438 22.253906-13.683594 29.484375-17.417969.003906.015625.007812.03125.011718.046875.027344.105468.050782.210937.070313.316406.027344.121094.046875.242188.0625.363281.015625.125.027344.25.039063.371094.015624.246094.019531.492187.003906.738281.003906.019532-.003906.039063 0 .058594-.007813.109375-.015625.222656-.027344.328125-.019531.207031-.054688.410156-.09375.621094-.035156.171875-.070312.347656-.117188.527343-.03125.125-.070312.253907-.105468.382813-.042969.128906-.082032.261719-.128906.386719-.046876.128906-.09375.257812-.144532.390625-.097656.253906-.214844.515625-.335937.773437-.054688.113282-.109375.226563-.167969.339844-.070312.144531-.148438.292969-.230469.4375-.070312.128906-.148437.261719-.21875.390625-.078125.128906-.15625.257813-.238281.386719-.074219.128906-.164062.257812-.246094.386718-.417968.640626-.890625 1.285157-1.394531 1.910157-.171875.21875-.355469.433593-.539063.65625-.132812.152343-.265624.304687-.402343.464843-.183594.203126-.363281.40625-.554688.609376-.019531.027343-.039062.046874-.0625.070312-.066406.074219-.140625.152344-.210937.222656-4.246094 4.5-9.566406 8.039063-9.800782 8.199219.371094-.089844 14.082032-3.3125 17.589844 5.738281 3.535156 9.101563-30.519531 15.316406-31.054687 15.414063.367187.097656 18.292969 4.875 14.785156 15.199219-3.523437 10.351562-38.84375 10.199218-39.386719 10.195312.492188.082031 21.539063 3.652344 16.816406 11.375zm0 0",
    fill: "url(#r)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m318.371094 101.125c-1.578125-.207031-3.074219.285156-4.0625 1.355469l-.015625.023437-2.777344 3.007813c-.691406.738281-1.371094 1.484375-2.042969 2.238281-1.554687-.351562-2.425781-.582031-2.425781-.582031s-.183594-.453125-.484375-1.28125c-.1875-.511719-.417969-1.171875-.683594-1.957031.5-.675782.996094-1.34375 1.5-2.015626.671875-.867187 1.335938-1.742187 2.003906-2.609374.746094-.96875 1.050782-2.242188.851563-3.5625-2.550781-16.929688 6.460937-27.640626 4.09375-20.546876-1.652344 4.941407-1.402344 13.582032-1.003906 19.167969 1.480469-1.800781 2.972656-3.582031 4.476562-5.355469 1.820313-2.078124 3.683594-4.121093 5.53125-6.179687.914063-1.035156 1.882813-2.015625 2.84375-3.007813l.945313-.972656c1.539062-1.585937 2.390625-3.765625 2.351562-6.136718-.308594-19.199219 9.382813-32.085938 6.320313-23.46875-2.234375 6.300781-2.773438 17.003906-2.875 23.75l2.050781-1.964844 4.535156-4.242188c.503906-.476562 1.011719-.945312 1.539063-1.386718.910156-.789063 2.421875-2.074219 3.886719-3.328126 2.488281-2.121093 4.191406-5.015624 4.933593-8.328124 4.515625-20.152344 18.503907-32.074219 12.972657-23.71875-4.339844 6.546874-7.964844 18.765624-9.71875 25.355468l.71875-.554687c1.085937-.851563 2.195312-1.679688 3.300781-2.511719 1.109375-.828125 2.183593-1.699219 3.347656-2.460938 2.285156-1.578124 4.582031-3.128906 6.890625-4.671874l1.738281-1.140626c.578125-.378906 1.148438-.773437 1.757813-1.113281 1.199218-.710937 2.390625-1.425781 3.601562-2.117187.160156-.09375.320313-.191406.480469-.28125.558594-.324219 1.1875.121094 1.339844.648437.089843.273438.046875.574219-.203125.796875-.136719.121094-.273438.242188-.40625.363282-1.027344.917968-2.0625 1.816406-3.09375 2.71875-.523438.445312-1.023438.910156-1.523438 1.378906l-1.507812 1.40625c-2.015625 1.851562-4.042969 3.691406-6.085938 5.507812-2.03125 1.828125-3.980468 3.753906-5.988281 5.597656-.191406.171876-.378906.34375-.566406.519532 6.230469-1.429688 19.824219-4.894532 26.953125-9.324219 8.851562-5.507813-4.753906 9.394531-26.484375 12.726563-3.113281.476562-5.902344 1.851562-8.101563 3.90625-1.292968 1.214843-2.671875 2.503906-3.667968 3.445312-1.949219 1.898438-3.871094 3.835938-5.808594 5.75l-2.875 2.8125c6.042968.164062 19.5.214844 26.96875-2.203125 9.015625-2.921875-5.359375 7.128906-25.65625 5.585937-2.710938-.210937-5.242188.644532-7.007813 2.429688l-.074219.082031-1.433593 1.453125c-.480469.480469-.933594.996094-1.410157 1.476563-1.886718 1.96875-3.753906 3.953125-5.660156 5.902343-1.355468 1.453126-2.699218 2.910157-4.054687 4.355469 5.597656.515625 13.871093.910157 18.707031-.5625 6.925781-2.101562-3.042969 5.917969-18.941406 3.824219zm0 0",
    fill: "url(#s)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m314.351562 100.144531c-.199218-.199219-.398437-.402343-.597656-.597656-16.921875-16.726563-44.4375-16.007813-60.484375 1.558594-29 31.746093-53.785156 67.449219-78.320312 102.734375-6.925781 9.960937-5.839844 23.492187 2.710937 32.09375.101563.101562.203125.203125.304688.304687 8.601562 8.550781 22.132812 9.636719 32.09375 2.710938 35.285156-24.535157 70.988281-49.320313 102.738281-78.320313 17.566406-16.046875 18.285156-43.5625 1.554687-60.484375zm0 0",
    fill: "url(#t)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m312.792969 160.628906c17.570312-16.046875 18.289062-43.5625 1.558593-60.484375-.199218-.199219-.398437-.402343-.597656-.597656-3.351562-3.3125-7.113281-5.9375-11.121094-7.882813v77.992188c3.425782-2.96875 6.816407-5.972656 10.160157-9.027344zm0 0",
    fill: "url(#v)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m268.917969 128.78125c3.90625 2.117188 7.628906 4.523438 11.285156 7.054688 1.816406 1.28125 3.613281 2.597656 5.371094 3.96875 1.742187 1.390624 3.460937 2.820312 5.140625 4.3125 1.664062 1.503906 3.386718 2.96875 5.019531 4.558593 1.621094 1.59375 3.078125 3.375 4.296875 5.34375 1.210938 1.96875 2.230469 4.09375 2.953125 6.34375.703125 2.246094 1.136719 4.648438.863281 7.039063l-.53125.125c-1.226562-1.949219-2.453125-3.679688-3.742187-5.367188-1.285157-1.679687-2.605469-3.300781-3.953125-4.914062-1.363282-1.605469-2.671875-3.25-3.9375-4.976563-1.273438-1.714843-2.585938-3.433593-4.039063-5.035156-1.445312-1.605469-2.949219-3.171875-4.484375-4.707031-1.519531-1.558594-3.089844-3.078125-4.683594-4.570313-3.175781-3.007812-6.476562-5.910156-9.859374-8.722656zm0 0",
    fill: "url(#w)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m209.21875 172.136719c3.980469 2.183593 7.785156 4.652343 11.519531 7.25 1.855469 1.316406 3.691407 2.667969 5.492188 4.070312 1.78125 1.425781 3.542969 2.886719 5.261719 4.410157 1.703124 1.539062 3.464843 3.039062 5.136718 4.660156 1.660156 1.632812 3.160156 3.449218 4.417969 5.445312 1.25 2.003906 2.308594 4.160156 3.066406 6.441406.738281 2.273438 1.203125 4.703126.953125 7.113282l-.53125.121094c-1.265625-1.980469-2.53125-3.742188-3.855468-5.460938-1.324219-1.710938-2.679688-3.363281-4.066407-5.007812-1.398437-1.632813-2.742187-3.3125-4.046875-5.066407-1.3125-1.746093-2.664062-3.496093-4.152344-5.128906-1.484374-1.640625-3.027343-3.238281-4.601562-4.808594-1.558594-1.589843-3.164062-3.140625-4.800781-4.667969-3.253907-3.070312-6.632813-6.039062-10.09375-8.914062zm0 0",
    fill: "url(#x)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m267.539062 101.53125c5.019532 1.734375 9.847657 3.886719 14.601563 6.21875 2.359375 1.191406 4.703125 2.429688 7.003906 3.75 2.28125 1.347656 4.539063 2.753906 6.75 4.25 2.195313 1.515625 4.460938 2.96875 6.625 4.597656 2.152344 1.648438 4.113281 3.574219 5.800781 5.796875 1.675782 2.230469 3.132813 4.714844 4.230469 7.433594 1.078125 2.714844 1.828125 5.707031 1.707031 8.859375l-.644531.300781c-1.691406-2.203125-3.367187-4.125-5.117187-5.96875-1.742188-1.839843-3.519532-3.59375-5.335938-5.332031-1.832031-1.722656-3.601562-3.511719-5.320312-5.414062-1.738282-1.886719-3.515625-3.769532-5.457032-5.464844-1.933593-1.703125-3.9375-3.339844-5.976562-4.929688-2.019531-1.625-4.101562-3.183594-6.210938-4.703125-4.203124-3.066406-8.546874-5.96875-12.988281-8.730469zm0 0",
    fill: "url(#y)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m255.757812 138.457031c3.175782 1.109375 6.195313 2.511719 9.152344 4.042969 1.46875.785156 2.917969 1.605469 4.335938 2.480469 1.402344.898437 2.785156 1.835937 4.128906 2.835937 1.332031 1.015625 2.714844 1.984375 4.019531 3.082032 1.292969 1.105468 2.441407 2.414062 3.386719 3.941406.933594 1.527344 1.707031 3.238281 2.222656 5.121094.503906 1.882812.777344 3.964843.457032 6.179687l-.449219.222656c-.949219-1.507812-1.90625-2.820312-2.921875-4.074219-1.007813-1.253906-2.046875-2.445312-3.113282-3.625-1.078124-1.167968-2.109374-2.386718-3.097656-3.679687-1.003906-1.285156-2.03125-2.570313-3.183594-3.71875-1.144531-1.152344-2.34375-2.253906-3.566406-3.328125-1.210937-1.09375-2.464844-2.140625-3.738281-3.160156-2.539063-2.0625-5.183594-4.003906-7.90625-5.84375zm0 0",
    fill: "url(#z)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m224.386719 171.464844c2.640625.738281 5.117187 1.769531 7.527343 2.929687 1.191407.597657 2.367188 1.226563 3.507813 1.914063 1.128906.707031 2.234375 1.453125 3.300781 2.261718 1.054688.828126 2.160156 1.605469 3.179688 2.511719 1.015625.914063 1.882812 2.03125 2.554687 3.367188.664063 1.34375 1.171875 2.875 1.441407 4.585937.257812 1.714844.296874 3.640625-.1875 5.742188l-.40625.25c-.679688-1.320313-1.382813-2.457032-2.140626-3.539063-.753906-1.078125-1.539062-2.097656-2.347656-3.101562-.820312-.992188-1.597656-2.035157-2.332031-3.15625-.742187-1.109375-1.511719-2.210938-2.398437-3.179688-.882813-.96875-1.8125-1.890625-2.769532-2.777343-.941406-.914063-1.921875-1.777344-2.929687-2.609376-2-1.691406-4.101563-3.261718-6.273438-4.730468zm0 0",
    fill: "url(#A)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m202.488281 202.125c2.640625.738281 5.113281 1.769531 7.523438 2.925781 1.191406.597657 2.367187 1.226563 3.511719 1.914063 1.125.710937 2.230468 1.457031 3.296874 2.265625 1.054688.828125 2.160157 1.605469 3.179688 2.511719 1.015625.914062 1.882812 2.03125 2.554688 3.367187.667968 1.34375 1.171874 2.875 1.441406 4.585937.261718 1.714844.296875 3.636719-.1875 5.742188l-.402344.25c-.679688-1.320312-1.386719-2.460938-2.144531-3.539062-.753907-1.078126-1.539063-2.097657-2.347657-3.101563-.820312-.992187-1.597656-2.035156-2.332031-3.15625-.742187-1.109375-1.511719-2.210937-2.398437-3.179687-.882813-.96875-1.8125-1.890626-2.769532-2.78125-.9375-.910157-1.921874-1.773438-2.929687-2.609376-1.996094-1.6875-4.101563-3.257812-6.273437-4.726562zm0 0",
    fill: "url(#B)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m231.054688 155.78125c3.890624 1.597656 7.628906 3.492188 11.308593 5.523438 1.828125 1.03125 3.644531 2.101562 5.425781 3.226562 1.769532 1.144531 3.515626 2.332031 5.226563 3.585938 1.699219 1.265624 3.453125 2.488281 5.125 3.839843 1.667969 1.363281 3.183594 2.925781 4.484375 4.695313 1.296875 1.773437 2.421875 3.726562 3.265625 5.832031.828125 2.105469 1.402344 4.398437 1.300781 6.761719l-.5.1875c-1.308594-1.753906-2.601562-3.296875-3.953125-4.785156-1.347656-1.484376-2.722656-2.90625-4.128906-4.316407-1.414063-1.402343-2.78125-2.847656-4.113281-4.378906-1.339844-1.515625-2.71875-3.039063-4.21875-4.425781-1.496094-1.390625-3.046875-2.738282-4.625-4.050782-1.5625-1.339843-3.171875-2.628906-4.804688-3.894531-3.253906-2.550781-6.617187-4.984375-10.054687-7.320312zm0 0",
    fill: "url(#C)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m407.71875 118.90625c-11.289062 0-22.007812 2.4375-31.664062 6.816406-6.800782 3.082032-14.621094 3.082032-21.425782 0-9.65625-4.378906-20.375-6.816406-31.664062-6.816406-42.496094 0-77.152344 34.949219-76.808594 77.441406.339844 42.132813 34.597656 76.179688 76.808594 76.179688 3.914062 0 7.761718-.292969 11.519531-.859375 20.4375-3.078125 41.277344-3.078125 61.714844 0 3.757812.566406 7.605469.859375 11.519531.859375 42.210938 0 76.46875-34.046875 76.808594-76.179688.34375-42.492187-34.3125-77.441406-76.808594-77.441406zm0 0",
    fill: "url(#D)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m378.320312 112.242188h-25.953124v-23.28125c0-7.167969 5.808593-12.976563 12.976562-12.976563s12.976562 5.808594 12.976562 12.976563zm0 0",
    fill: "url(#E)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m366.15625 110.28125c-10.238281-5.597656-41.464844-18.84375-69.242188 9-1.566406 1.570312-1.269531 4.160156.535157 5.320312l49.511719 49.511719c.320312.496094.777343.917969 1.367187 1.199219 11.671875 5.59375 45.785156 18.390625 69.257813-9.269531 1.355468-1.601563 1.019531-4-.699219-5.121094zm0 0",
    fill: "url(#G)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m397.175781 186.097656c0-35.125-31.949219-63.601562-71.363281-63.601562-39.410156 0-71.363281 28.476562-71.363281 63.601562 0 35.128906 31.953125 63.605469 71.363281 63.605469 39.414062 0 71.363281-28.476563 71.363281-63.605469zm0 0",
    fill: "url(#H)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m434.113281 123.707031.046875-.074219c-8.253906-3.050781-17.15625-4.726562-26.4375-4.726562-11.292968 0-22.011718 2.4375-31.664062 6.816406-6.804688 3.082032-14.625 3.082032-21.429688 0-8.214844-3.726562-17.207031-6.039062-26.660156-6.648437-8.785156 6.484375-16.691406 16.453125-21.011719 31.742187-.558593 1.972656.609375 3.925782 2.425781 4.464844l115.355469 115.351562c34.035157-7.695312 59.5-37.988281 59.792969-74.28125.074219-9.441406-1.585938-18.5-4.667969-26.894531zm0 0",
    fill: "url(#I)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m364.941406 109.871094c8.90625 8.410156 25.996094 14.632812 7.199219 51.378906-1.132813 2.210938-4.101563 2.683594-5.816406.882812-9.363281-9.839843-26.941407-19.089843-6.929688-51.480468 1.203125-1.953125 3.878907-2.355469 5.546875-.78125zm0 0",
    fill: "url(#J)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m366.15625 110.28125c-10.238281-5.597656-41.464844-18.84375-69.242188 9-1.671874 1.675781-1.222656 4.507812.910157 5.53125 11.671875 5.59375 45.785156 18.390625 69.257812-9.273438 1.417969-1.667968.992188-4.207031-.925781-5.257812zm0 0",
    fill: "url(#K)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m364.53125 110.28125c10.238281-5.597656 41.464844-18.84375 69.238281 9 1.675781 1.675781 1.226563 4.507812-.90625 5.53125-11.671875 5.59375-45.785156 18.390625-69.257812-9.273438-1.417969-1.667968-.996094-4.207031.925781-5.257812zm0 0",
    fill: "url(#L)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m365.820312 107.175781c-12.246093.101563-47.636718 3.921875-58.863281 43.640625-.675781 2.390625 1.179688 4.757813 3.660157 4.605469 13.558593-.839844 51.363281-6.546875 58.738281-43.898437.445312-2.253907-1.238281-4.367188-3.535157-4.347657zm0 0",
    fill: "url(#M)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m366.351562 107.214844c12.238282.503906 47.484376 5.476562 57.410157 45.535156.597656 2.414062-1.335938 4.71875-3.808594 4.484375-13.523437-1.28125-51.121094-8.21875-57.277344-45.789063-.371093-2.265624 1.382813-4.324218 3.675781-4.230468zm0 0",
    fill: "url(#N)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m85.714844 137.285156s-32.230469-41.265625 32.21875-57.5c2.6875-.679687 5.425781.90625 6.210937 3.566406 3.785157 12.785157 9.585938 47.941407-38.429687 53.933594zm0 0",
    fill: "url(#O)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m124.144531 83.351562c-.433593-1.476562-1.472656-2.617187-2.765625-3.230468-20.132812 24.90625-35.664062 57.164062-35.664062 57.164062 48.015625-5.988281 42.214844-41.148437 38.429687-53.933594zm0 0",
    fill: "url(#P)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m114.378906 100c-.492187.210938-1.003906.386719-1.503906.566406-.5.179688-.996094.359375-1.503906.511719-.503906.164063-1.03125.257813-1.550782.355469-.515624.097656-1 .273437-1.460937.523437-.457031.257813-.902344.535157-1.34375.871094.34375-.636719.691406-1.273437 1.035156-1.914063l1.722657-3.101562c.570312-1.039062 1.195312-2.03125 1.78125-3.0625 1.207031-2.035156 2.480468-4.007812 3.894531-5.902344l-.394531-.378906-1.292969 1.261719-.648438.632812c-.210937.21875-.402343.445313-.605469.667969-.785156.902344-1.621093 1.785156-2.359374 2.726562-1.535157 1.847657-2.96875 3.765626-4.414063 5.679688-.269531.375-.539063.75-.808594 1.125-.023437-.386719-.074219-.761719-.1875-1.140625-.148437-.503906-.3125-1.015625-.398437-1.539063-.097656-.519531-.164063-1.042968-.234375-1.570312-.070313-.527344-.148438-1.058594-.1875-1.59375-.128907-1.074219-.160157-2.15625-.21875-3.269531l-.300781-.058594c-.417969 1.039063-.757813 2.121094-1.003907 3.226563-.128906.554687-.222656 1.113281-.320312 1.675781-.066407.5625-.136719 1.128906-.175781 1.699219-.042969.570312-.117188 1.144531-.167969 1.726562-.039063.578125.019531 1.152344.199219 1.707031.035156.109375.074218.214844.113281.324219.441406 1.171875.257812 2.488281-.449219 3.519531l-.011719.019531c-1.230469 1.796876-2.421875 3.617188-3.621093 5.433594-.046876-.539062-.132813-1.042968-.246094-1.539062-.121094-.511719-.3125-.988282-.585938-1.4375-.273437-.453125-.558594-.910156-.769531-1.390625-.226563-.480469-.421875-.96875-.621094-1.464844-.199219-.492187-.410156-.988281-.582031-1.496094-.394531-1.007812-.691406-2.046875-1.03125-3.109375l-.304688.019532c-.140624 1.113281-.203124 2.242187-.164062 3.375.011719.566406.066406 1.132812.113281 1.703124.074219.558594.148438 1.125.253907 1.6875.101562.5625.171874 1.136719.269531 1.714844.105469.570313.308593 1.113282.617187 1.601563.140625.214843.292969.429687.453125.632812.789063 1 .796875 2.414063.078125 3.464844-.613281.90625-1.230468 1.808594-1.839844 2.71875-.773437 1.152344-1.484374 2.335937-2.144531 3.546875-.050781-.464844-.128906-.902344-.226562-1.335938-.121094-.511718-.3125-.988281-.585938-1.441406-.273437-.453125-.558593-.90625-.769531-1.390625-.226562-.476562-.421875-.96875-.621094-1.460937-.203125-.492188-.410156-.988282-.582031-1.496094-.394531-1.011719-.695313-2.050781-1.03125-3.113281l-.304687.023437c-.144532 1.109375-.203126 2.242188-.164063 3.371094.011719.570312.0625 1.132812.109375 1.703125.074219.5625.152344 1.128906.257812 1.6875.097657.5625.167969 1.140625.265626 1.714844.109374.570312.308593 1.113281.621093 1.605469.316407.480468.675781.949218 1.121094 1.363281.511719.46875.679687 1.199219.402344 1.835937-.726563 1.644532-2.011719 4.632813-2.585938 6.265625-.78125 2.285157-1.484375 4.609375-1.894531 7.078125l.488281.253906c1.800781-1.730468 3.351563-3.585937 4.824219-5.484374 1.464844-1.898438 2.832031-3.847657 4.113281-5.84375.023438-.035157.046875-.070313.070313-.105469.414062-.640625 1.207031-.886719 1.929687-.640625.535157.179687 1.078125.277344 1.617188.332031.578125.050781 1.152343-.023437 1.707031-.1875.554688-.179687 1.097656-.382813 1.644531-.550781.546875-.164063 1.082031-.359375 1.617188-.550782.527343-.222656 1.050781-.433593 1.5625-.683593 1.019531-.488281 2-1.0625 2.917969-1.699219l-.121094-.28125c-1.097656.191406-2.160156.40625-3.234375.519531-.53125.078125-1.066407.121094-1.597657.171875-.53125.046875-1.054687.097656-1.585937.121094-.527344.03125-1.0625-.011719-1.585937-.042969-.527344-.039062-1.039063.011719-1.546876.136719-.550781.148438-1.097656.328125-1.65625.574219.601563-1.085938 1.171876-2.191407 1.703126-3.316407.417968-.902343.996093-2.113281 1.507812-3.175781.539062-1.128906 1.742188-1.816406 2.984375-1.640625.605469.085938 1.222656.082032 1.78125.140625.578125.050781 1.152344-.019531 1.707031-.1875.554688-.179687 1.097656-.382812 1.644532-.550781.546874-.164062 1.085937-.359375 1.617187-.550781.527344-.21875 1.054687-.433594 1.5625-.683594 1.023437-.488281 2-1.0625 2.917969-1.699219l-.121094-.28125c-1.097656.191406-2.15625.40625-3.234375.519532-.53125.078124-1.066406.121093-1.597656.171874-.53125.050782-1.054688.097657-1.582031.121094-.527344.035156-1.0625-.011718-1.589844-.042968-.527344-.035157-1.039063.011718-1.546875.140624-.96875.257813-1.925781.605469-2.972657 1.296876 1.09375-2.09375 2.171876-4.203126 3.296876-6.277344l.042968-.082032c.652344-1.277343 1.949219-2.140624 3.386719-2.144531.40625-.003906.804687-.042969 1.195313-.101562.574218-.097657 1.113281-.308594 1.609374-.609375.488282-.3125.964844-.644532 1.453126-.945313.488281-.296875.957031-.621093 1.425781-.9375.457031-.347656.910156-.683593 1.339843-1.054687.871094-.726563 1.671876-1.527344 2.402344-2.375l-.1875-.242188c-1.011718.457032-1.988281.929688-3 1.308594zm0 0",
    fill: "url(#Q)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m81.050781 129.660156c-.511719-.640625-1.039062-1.265625-1.597656-1.878906-.386719-.4375-.800781-.851562-1.207031-1.273438-.421875-.410156-.84375-.820312-1.289063-1.210937-.433593-.394531-.882812-.769531-1.335937-1.148437-.464844-.363282-.925782-.726563-1.402344-1.0625-1.507812-1.09375-3.109375-2.042969-4.75-2.824219-.183594-.457031-.375-.910157-.574219-1.363281-.796875-1.78125-1.710937-3.523438-2.765625-5.179688-1.058594-1.652344-2.261718-3.226562-3.640625-4.621094-.21875-.226562-.550781-.277344-.761719-.105468-.234374.191406-.246093.570312-.027343.851562l.003906.007812c2.167969 2.761719 3.714844 5.953126 4.820313 9.195313-1.585938-.554687-3.1875-.953125-4.785157-1.1875-4.308593-.65625-8.519531-.171875-12.265625 1.28125-3.734375 1.46875-7.085937 3.914063-9.40625 7.457031-1.160156 1.761719-2.027344 3.808594-2.488281 6.019532-.230469 1.101562-.359375 2.257812-.390625 3.394531-.027344 1.085937.011719 2.210937.144531 3.359375.269531 2.292968.917969 4.71875 2.078125 7.027344.585938 1.152343 1.285156 2.269531 2.097656 3.296874.816407 1.03125 1.730469 1.980469 2.722657 2.792969 1.988281 1.636719 4.230469 2.757813 6.429687 3.351563 2.207032.609375 4.375.707031 6.386719.445312 4.03125-.550781 7.390625-2.546875 9.855469-5.210937.617187-.664063 1.1875-1.371094 1.710937-2.105469.515625-.726562 1.027344-1.539062 1.445313-2.363281.847656-1.660157 1.457031-3.445313 1.851562-5.277344.375-1.730469.5-2.734375.539063-4.519531 0 0 6.164062 11.632812.921875 25.40625-1.078125 2.839844 1.808594 6.285156 4.6875 5.570312.027344-.003906.054687-.011718.078125-.019531 7.039062-1.796875 17.515625-6.867187 26.550781-20.925781 1.460938-2.277344-.359375-5.832032-3.199219-6.195313-5.460937-.695312-13.382812-3.175781-20.4375-10.984375zm-13.59375 9.679688c-.472656 1.441406-1.105469 2.773437-1.890625 3.945312-.761718 1.160156-1.769531 2.207032-2.835937 3.085938-2.128907 1.769531-4.703125 2.820312-7.316407 2.859375-1.296874.019531-2.59375-.207031-3.769531-.671875-1.183593-.457032-2.230469-1.15625-3.074219-1.992188-1.703124-1.65625-2.585937-3.949218-2.664062-6.523437-.023438-.644531.007812-1.300781.085938-1.960938.074218-.617187.195312-1.175781.367187-1.726562.34375-1.097657.890625-2.089844 1.617187-2.957031.722657-.871094 1.636719-1.601563 2.675782-2.160157 1.035156-.570312 2.183594-.988281 3.398437-1.230469 2.429688-.507812 5.058594-.371093 7.582031.21875 2.410157.554688 4.734376 1.53125 6.941407 2.875-.125 2.195313-.476563 4.308594-1.117188 6.238282zm0 0",
    fill: "url(#R)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m69.464844 120.261719c-.183594-.457031-.375-.910157-.574219-1.363281-.792969-1.78125-1.707031-3.523438-2.765625-5.175782-1.058594-1.65625-2.261719-3.230468-3.636719-4.625-.222656-.226562-.550781-.277344-.765625-.105468-.234375.191406-.246094.570312-.027344.851562l.007813.007812c2.164063 2.761719 3.710937 5.953126 4.816406 9.195313zm0 0",
    fill: "url(#T)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m67.457031 139.339844c-.472656 1.441406-1.105469 2.773437-1.890625 3.945312-.335937.511719-.722656.996094-1.140625 1.457032l3.632813 4.953124c.1875-.242187.375-.480468.550781-.726562.515625-.726562 1.027344-1.539062 1.445313-2.363281.851562-1.660157 1.457031-3.445313 1.851562-5.277344.375-1.730469.503906-2.734375.542969-4.519531-1.171875-2.160156-3.875-3.707032-3.875-3.707032-.125 2.195313-.476563 4.308594-1.117188 6.238282zm0 0",
    fill: "url(#U)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m101.488281 140.644531c-5.464843-.695312-13.382812-3.175781-20.4375-10.984375-.511719-.640625-1.039062-1.265625-1.597656-1.878906-.386719-.4375-.800781-.851562-1.207031-1.273438-.421875-.410156-.84375-.820312-1.289063-1.210937-.433593-.394531-.882812-.769531-1.335937-1.148437-.464844-.363282-.925782-.726563-1.402344-1.0625-1.507812-1.09375-3.109375-2.042969-4.75-2.824219-.183594-.457031-.375-.910157-.574219-1.363281-.796875-1.78125-1.710937-3.523438-2.765625-5.179688-1.058594-1.652344-2.261718-3.226562-3.640625-4.621094-.21875-.226562-.550781-.277344-.761719-.105468-.234374.191406-.246093.570312-.027343.851562l.003906.007812c2.167969 2.761719 3.714844 5.953126 4.820313 9.195313-1.585938-.554687-3.1875-.953125-4.785157-1.1875-4.308593-.65625-8.519531-.171875-12.265625 1.28125-3.734375 1.46875-7.085937 3.914063-9.40625 7.457031-1.160156 1.761719-2.027344 3.808594-2.488281 6.019532-.230469 1.101562-.359375 2.257812-.390625 3.394531 0 0 12.648438-19.777344 26.960938-11.292969 11.359374 6.730469 21.054687 22.765625 33.40625 31.238281 2.414062-2.511719 4.816406-5.519531 7.128906-9.109375 1.460937-2.28125-.355469-5.839844-3.195313-6.203125zm0 0",
    fill: "url(#V)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m207.101562 284.433594c0 14.777344-11.984374 26.757812-26.761718 26.757812-14.78125 0-26.761719-11.980468-26.761719-26.757812 0-14.78125 11.980469-26.761719 26.761719-26.761719 14.777344 0 26.761718 11.980469 26.761718 26.761719zm0 0",
    fill: "url(#W)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m208.574219 245.96875c0 14.78125-11.980469 26.761719-26.761719 26.761719-14.777344 0-26.757812-11.980469-26.757812-26.761719 0-14.777344 11.980468-26.761719 26.757812-26.761719 14.78125 0 26.761719 11.984375 26.761719 26.761719zm0 0",
    fill: "url(#X)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m202.457031 209.675781c0 14.777344-11.980469 26.761719-26.761719 26.761719-14.777343 0-26.757812-11.984375-26.757812-26.761719 0-14.78125 11.980469-26.761719 26.757812-26.761719 14.78125 0 26.761719 11.980469 26.761719 26.761719zm0 0",
    fill: "url(#Y)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m204.242188 165.351562c0 14.78125-11.984376 26.761719-26.761719 26.761719-14.78125 0-26.761719-11.980469-26.761719-26.761719 0-14.777343 11.980469-26.757812 26.761719-26.757812 14.777343 0 26.761719 11.980469 26.761719 26.757812zm0 0",
    fill: "url(#aa)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m201.914062 268.601562c-.703124-.957031-1.464843-1.847656-2.261718-2.6875 10.167968-9.074218 11.964844-24.5625 3.734375-35.777343-1.582031-2.160157-3.433594-4.007813-5.46875-5.542969 6.105469-9.097656 6.207031-21.40625-.648438-30.75-1.648437-2.25-3.585937-4.164062-5.722656-5.734375.597656-.371094 1.1875-.757813 1.765625-1.179687 11.914062-8.746094 14.484375-25.492188 5.742188-37.410157-8.742188-11.914062-25.492188-14.484375-37.40625-5.742187-11.914063 8.746094-14.488282 25.492187-5.742188 37.40625 1.648438 2.25 3.585938 4.167968 5.722656 5.738281-.597656.367187-1.1875.757813-1.765625 1.179687-11.914062 8.742188-14.488281 25.492188-5.742187 37.40625 1.585937 2.160157 3.433594 4.007813 5.46875 5.542969-6.105469 9.097657-6.207032 21.40625.648437 30.75.703125.957031 1.460938 1.847657 2.261719 2.683594-8.117188 7.246094-10.894531 18.574219-7.5 28.554687l46.933594 7.207032c6.71875-9.167969 7.0625-21.992188-.019532-31.644532zm0 0",
    fill: "url(#ac)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m170.292969 269.121094c0 14.78125-11.980469 26.761718-26.761719 26.761718-14.777344 0-26.757812-11.980468-26.757812-26.761718 0-14.777344 11.980468-26.761719 26.757812-26.761719 14.78125 0 26.761719 11.984375 26.761719 26.761719zm0 0",
    fill: "url(#ad)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m165.109375 253.289062c-8.746094-11.914062-25.492187-14.484374-37.410156-5.742187-9.050781 6.640625-12.703125 17.898437-10.105469 28.152344l48.710938 7.480469c5.550781-9.003907 5.445312-20.839844-1.195313-29.890626zm0 0",
    fill: "url(#ae)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m165.953125 226.222656c0 14.777344-11.980469 26.761719-26.761719 26.761719-14.777344 0-26.761718-11.984375-26.761718-26.761719 0-14.78125 11.984374-26.761718 26.761718-26.761718 14.78125 0 26.761719 11.980468 26.761719 26.761718zm0 0",
    fill: "url(#af)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m166.671875 181.144531c0 14.78125-11.980469 26.761719-26.761719 26.761719-14.777344 0-26.761718-11.980469-26.761718-26.761719 0-14.777343 11.984374-26.761719 26.761718-26.761719 14.78125 0 26.761719 11.984376 26.761719 26.761719zm0 0",
    fill: "url(#ag)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m169.117188 145.769531c0 14.777344-11.980469 26.757813-26.761719 26.757813-14.777344 0-26.757813-11.980469-26.757813-26.757813 0-14.78125 11.980469-26.761719 26.757813-26.761719 14.78125 0 26.761719 11.980469 26.761719 26.761719zm0 0",
    fill: "url(#ah)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m167.964844 153.519531-52.367188-8.042969c-.0625 5.601563 1.617188 11.265626 5.183594 16.125.117188.160157.242188.3125.363281.46875-9.34375 9.167969-10.78125 24.042969-2.808593 34.90625 1.921874 2.621094 4.234374 4.789063 6.796874 6.484376-.601562.371093-1.195312.761718-1.773437 1.1875-11.914063 8.742187-14.484375 25.488281-5.742187 37.40625 8.746093 11.914062 25.492187 14.484374 37.40625 5.742187 11.917968-8.742187 14.488281-25.492187 5.746093-37.40625-1.925781-2.621094-4.234375-4.789063-6.796875-6.484375.597656-.371094 1.191406-.761719 1.769532-1.1875 11.917968-8.742188 14.488281-25.488281 5.746093-37.40625-.117187-.160156-.242187-.3125-.363281-.46875 3.273438-3.214844 5.570312-7.128906 6.839844-11.324219zm0 0",
    fill: "url(#ai)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m129.25 253.664062c0 14.78125-11.980469 26.761719-26.757812 26.761719-14.78125 0-26.761719-11.980469-26.761719-26.761719 0-14.777343 11.980469-26.757812 26.761719-26.757812 14.777343 0 26.757812 11.980469 26.757812 26.757812zm0 0",
    fill: "url(#aj)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m86.660156 232.089844c-9.960937 7.308594-13.386718 20.210937-9.136718 31.207031l45.894531 7.046875c7.355469-9.214844 7.957031-22.550781.648437-32.511719-8.742187-11.914062-25.492187-14.484375-37.40625-5.742187zm0 0",
    fill: "url(#ak)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m128.484375 208.65625c0 14.777344-11.984375 26.757812-26.761719 26.757812-14.78125 0-26.761718-11.980468-26.761718-26.757812 0-14.78125 11.980468-26.761719 26.761718-26.761719 14.777344 0 26.761719 11.980469 26.761719 26.761719zm0 0",
    fill: "url(#al)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m92.824219 238.917969c0 14.777343-11.980469 26.761719-26.757813 26.761719-14.78125 0-26.761718-11.984376-26.761718-26.761719 0-14.78125 11.980468-26.761719 26.761718-26.761719 14.777344 0 26.757813 11.980469 26.757813 26.761719zm0 0",
    fill: "url(#am)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m126.148438 166.871094c0 14.78125-11.984376 26.761718-26.761719 26.761718-14.78125 0-26.761719-11.980468-26.761719-26.761718s11.980469-26.761719 26.761719-26.761719c14.777343 0 26.761719 11.980469 26.761719 26.761719zm0 0",
    fill: "url(#an)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m90.128906 196.859375c0 14.777344-11.984375 26.761719-26.761718 26.761719-14.78125 0-26.761719-11.984375-26.761719-26.761719 0-14.78125 11.980469-26.761719 26.761719-26.761719 14.777343 0 26.761718 11.980469 26.761718 26.761719zm0 0",
    fill: "url(#ao)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m326.238281 498.136719h-140.476562c-93.78125 0-169.808594-76.027344-169.808594-169.808594v-109.808594h480.09375v109.808594c0 93.78125-76.023437 169.808594-169.808594 169.808594zm0 0",
    fill: "url(#ap)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m190.546875 218.519531v109.808594c0 63.832031-35.226563 119.429687-87.296875 148.433594 24.429688 13.609375 52.5625 21.375 82.511719 21.375h140.476562c93.78125 0 169.808594-76.027344 169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#aq)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m263.996094 218.519531v109.808594c0 77.914063-52.480469 143.570313-124.023438 163.554687 14.566406 4.070313 29.921875 6.253907 45.789063 6.253907h140.476562c93.78125 0 169.808594-76.027344 169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#ar)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m338.507812 218.519531v109.808594c0 90.921875-71.457031 165.148437-161.277343 169.59375 2.824219.140625 5.671875.214844 8.53125.214844h140.476562c93.785157 0 169.808594-76.027344 169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#as)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m413.359375 218.519531v109.808594c0 93.78125-76.023437 169.808594-169.808594 169.808594h82.6875c93.78125 0 169.808594-76.027344 169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#at)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m321.453125 218.519531v109.808594c0 63.832031 35.226563 119.429687 87.296875 148.433594-24.429688 13.609375-52.5625 21.375-82.511719 21.375h-140.476562c-93.78125 0-169.808594-76.027344-169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#au)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m248.003906 218.519531v109.808594c0 77.914063 52.480469 143.570313 124.023438 163.554687-14.566406 4.070313-29.921875 6.253907-45.789063 6.253907h-140.476562c-93.78125 0-169.808594-76.027344-169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#av)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m173.492188 218.519531v109.808594c0 90.921875 71.457031 165.148437 161.277343 169.59375-2.824219.140625-5.671875.214844-8.53125.214844h-140.476562c-93.78125 0-169.808594-76.027344-169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#aw)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m98.640625 218.519531v109.808594c0 93.78125 76.023437 169.808594 169.808594 169.808594h-82.6875c-93.78125 0-169.808594-76.027344-169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#ax)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m15.953125 218.519531v41.871094l237.746094 237.746094h72.539062c93.785157 0 169.808594-76.027344 169.808594-169.808594v-109.808594zm0 0",
    fill: "url(#ay)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m476.347656 264.21875h-440.695312c-19.6875 0-35.652344-15.960938-35.652344-35.65625 0-19.691406 15.964844-35.652344 35.652344-35.652344h440.691406c19.691406 0 35.65625 15.964844 35.65625 35.652344 0 19.695312-15.964844 35.65625-35.652344 35.65625zm0 0",
    fill: "url(#az)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.8daa8f6f41b05e56504b298b26e552b3.svg";
export { ForwardRef as ReactComponent };